import { computed, defineComponent, renderSlot, watch } from 'vue'
import { provideGlobalConfig } from './hooks/use-global-config'
import { useHtmlDark } from './hooks/use-html-dark'
import { configProviderProps } from './config-provider-props'

import type { MessageConfigContext } from '@zoryn/components/message'

export const messageConfig: MessageConfigContext = {
  placement: 'top',
}

const ConfigProvider = defineComponent({
  name: 'ZConfigProvider',
  props: configProviderProps,

  setup(props, { slots }) {
    const config = provideGlobalConfig(props)
    if (!config) {
      return () => renderSlot(slots, 'default', { config: undefined })
    }
    useHtmlDark(computed(() => config.value?.dark))
    watch(
      () => props.message,
      (val) => {
        Object.assign(messageConfig, config.value?.message ?? {}, val ?? {})
      },
      { immediate: true, deep: true }
    )
    return () => renderSlot(slots, 'default', { config: config.value })
  },
})
export type ConfigProviderInstance = InstanceType<typeof ConfigProvider> &
  unknown

export default ConfigProvider
